__turbopack_context__.v({
  "borderline": "SplitAccordionSection-module__KKyMPW__borderline",
  "chevron": "SplitAccordionSection-module__KKyMPW__chevron",
  "content": "SplitAccordionSection-module__KKyMPW__content",
  "grid": "SplitAccordionSection-module__KKyMPW__grid",
  "left": "SplitAccordionSection-module__KKyMPW__left",
  "right": "SplitAccordionSection-module__KKyMPW__right",
  "section": "SplitAccordionSection-module__KKyMPW__section",
  "structured": "SplitAccordionSection-module__KKyMPW__structured",
  "summary": "SplitAccordionSection-module__KKyMPW__summary",
});
